import { ICoordinates } from '../../../types/types';
import { BaseFootprint } from './BaseFootprint';

export class BaseLocation {
  constructor(
    private readonly _locationId: string,
    private readonly _kakaoUid: string | null,
    private readonly _naverUid: string | null,
    private readonly _googleUid: string | null,
    private readonly _name: string,
    private readonly _description: string | null,
    private readonly _category: string,
    private readonly _siteType: string,
    private readonly _streetAddress: string,
    private readonly _lotAddress: string,
    private readonly _latitude: number,
    private readonly _longitude: number,
    private readonly _likesCount: number,
    private readonly _postsCount: number,
    private readonly _distanceInMeters: number | null,
    private readonly _isLiked: boolean,
    private readonly _isLandmark: boolean,
    private readonly _isShutdown: boolean,
    private readonly _footprints: BaseFootprint[]
  ) {}

  get locationId(): string {
    return this._locationId;
  }

  get kakaoUid(): string | null {
    return this._kakaoUid;
  }

  get naverUid(): string | null {
    return this._naverUid;
  }

  get googleUid(): string | null {
    return this._googleUid;
  }

  get name(): string {
    return this._name;
  }

  get description(): string | null {
    return this._description;
  }

  get category(): string {
    return this._category;
  }

  get siteType(): string {
    return this._siteType;
  }

  get streetAddress(): string {
    return this._streetAddress;
  }

  get lotAddress(): string {
    return this._lotAddress;
  }

  get latitude(): number {
    return this._latitude;
  }

  get longitude(): number {
    return this._longitude;
  }

  get likesCount(): number {
    return this._likesCount;
  }

  get postsCount(): number {
    return this._postsCount;
  }

  get distanceInMeters(): number | null {
    return this._distanceInMeters;
  }

  get isLiked(): boolean {
    return this._isLiked;
  }

  get isLandmark(): boolean {
    return this._isLandmark;
  }

  get isShutdown(): boolean {
    return this._isShutdown;
  }

  get footprints(): BaseFootprint[] {
    return this._footprints;
  }

  public getFormattedDistance(): string {
    if (!this._distanceInMeters) return 'N/A';
    if (this._distanceInMeters < 1000) {
      return `${this._distanceInMeters}m`;
    }
    return `${(this._distanceInMeters / 1000).toFixed(1)}km`;
  }

  public getCoordinates(): ICoordinates {
    return {
      lat: this._latitude,
      lng: this._longitude
    };
  }

  public footprintArtistMemberNames(): string {
    return this.footprints
      .map((footprint) => footprint.footprinterName)
      .filter((name) => name !== '')
      .join(', ');
  }

  public siteTypeIconName(): string {
    switch (this.siteType) {
      case 'birthday_cafe':
        return '3D.Birthday cake';
      case 'experience_space':
        return '3D.Exhibition';
      case 'billboard_ad':
        return '3D.Signboard';
      case 'filming_location':
        return '3D.clapper_board';
      case 'foodie_spot':
        return '3D.Restaurant';
      case 'landmark':
        return '3D.Place';
      default:
        return '3D.Place';
    }
  }
}
